import React from "react";
import { LARGE_ORDERS_CONFIG } from "./constants";
import { FormConfigPage } from "./FormConfigPage";

export function LargeOrders() {
    return <FormConfigPage config={LARGE_ORDERS_CONFIG} />;
}
